<template>
  <div>
    <!-- {{ GET_APPLICATIONS_GOOD_RETURN.results[0] }} -->
    <!-- {{ GET_APPLICATIONS_INSTRUMENT_RETURN.results[0] }} -->
    <b-row>
      <b-col class="col-md-2">
        <AppSearchInput
          v-model="filter.search"
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="refresh"
        />
      </b-col>

      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('filter_by_destination_warehouse') + ':'">
          <v-select
            class="bg-white rounded"
            label="title"
            v-model="filter.storage"
            :reduce="(data) => data.id"
            :options="GET_APPLICATION_TYPE"
            @input="refresh"
          />
        </b-form-group>
      </b-col>

      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('dateFromTo') + ':'">
          <VueDataPicker
            placeholder=""
            :other-props="{ 'is-range': true }"
            @input="datePicker"
          />
        </b-form-group>
      </b-col>

      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('filter_by_author') + ':'">
          <v-select
            class="bg-white rounded"
            v-model="filter.author"
            :get-option-label="
              (el) => {
                return el.first_name + ' ' + el.last_name;
              }
            "
            :options="GET_APPLICATION_AUTHOR.results"
            :reduce="(p) => p.id"
            @input="refresh"
          />
        </b-form-group>
      </b-col>

      <b-col
        class="
          col-lg-4 col-md-3 col-12
          d-flex
          align-items-center
          justify-content-end
        "
        style="margin-top: 10px"
      >
        <b-form-radio-group
          id="radio-dark"
          v-model="card"
          class="list item-view-radio-group"
          buttons
          button-variant="outline-primary"
        >
          <b-form-radio
            v-for="option in itemViewOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.text }}
          </b-form-radio>
        </b-form-radio-group>
      </b-col>

      <b-col>
        <b-card v-if="!isLoading">
          <template v-if="card">
            <MaterialTable @refresh="refresh" />
          </template>
          <template v-else>
            <InstrumentTable @refresh="refresh" />
          </template>
        </b-card>
        <b-card v-else>
          <Loader />
        </b-card>
      </b-col>

      <Pagination
        v-if="card"
        class="w-100"
        :params="filter"
        :rows="GET_APPLICATIONS_GOOD_RETURN.count"
        @refresh="refresh"
      />
      <Pagination
        v-if="!card"
        class="w-100"
        :params="filter"
        :rows="GET_APPLICATIONS_INSTRUMENT_RETURN.count"
        @refresh="refresh"
      />
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BButton,
  BTable,
  VBTooltip,
  BFormRadio,
  BFormRadioGroup,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import AppSearchInput from "@/components/AppSearchInput.vue";
import VueDataPicker from "@/components/VueDatePicker.vue";
import Pagination from "@/components/Pagination.vue";
import areYouSure from "@/mixins/areYouSure";
import check from "@/mixins/check";
import MaterialTable from "./tables/materialTable.vue";
import InstrumentTable from "./tables/instrumenTable.vue";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    AppSearchInput,
    VueDataPicker,
    Pagination,
    vSelect,
    Loader,
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BTable,
    BBadge,
    BCard,
    BFormRadio,
    BFormRadioGroup,
    MaterialTable,
    InstrumentTable,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [areYouSure, check, loader],
  data() {
    return {
      isLoading: false,
      card: true,
      filter: {
        search: null,
        requirement_type: null,
        author: null,
        storage: null,
        start_date: null,
        end_date: null,

        page_size: 10,
        page: 1,
      },
      itemViewOptions: [
        {
          text: this.$t("reference.material"),
          value: true,
        },
        {
          text: this.$t("reference.instrument"),
          value: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("application", [
      "GET_APPLICATIONS_GOOD_RETURN",
      "GET_APPLICATIONS_INSTRUMENT_RETURN",
      "GET_APPLICATION_TYPE",
      "GET_APPLICATION_AUTHOR",
    ]),
  },
  async mounted() {
    // await this.$_loaderStart();
    this.isLoading = true;
    await this.FETCH_APPLICATION_GOOD_RETURN(this.filter);
    await this.FETCH_APPLICATION_INSTRUMENT_RETURN(this.filter);
    this.isLoading = false;
    await this.FETCH_APPLICATION_TYPE({ is_object: true, mini: true });
    await this.FETCH_APPLICATION_AUTHOR({ role_unique_name: "builder" });
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("application", [
      "FETCH_APPLICATION_GOOD_RETURN",
      "FETCH_APPLICATION_INSTRUMENT_RETURN",
      "UPDATE_APPLICATION_GOOD_RETURN",
      "FETCH_APPLICATION_TYPE",
      "FETCH_APPLICATION_AUTHOR",
    ]),

    async refresh() {
      // await this.FETCH_APPLICATION_TYPE({ is_object: true, mini: true });
      // await this.FETCH_APPLICATION_AUTHOR({ role_unique_name: "builder" });

      if (this.card) {
        this.isLoading = true;
        await this.FETCH_APPLICATION_GOOD_RETURN(this.filter);
        this.isLoading = false;
      } else {
        this.isLoading = true;

        await this.FETCH_APPLICATION_INSTRUMENT_RETURN(this.filter);
        this.isLoading = false;
      }
    },

    async datePicker(e) {
      if (e) {
        this.isLoading = true;
        this.filter.start_date = e.start;
        this.filter.end_date = e.end;
        await this.FETCH_APPLICATION_GOOD_RETURN(this.filter);
        await this.FETCH_APPLICATION_INSTRUMENT_RETURN(this.filter);
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

//  кнопка переключения между заявками и инструментами
[dir] .btn-outline-primary:not(:disabled):not(.disabled).active {
  background-color: #5a9cd9;
  color: white;
}
#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
